<!-- eslint-disable -->
<template lang="pug">
    .row.user-preview
        .col-xs-10.user-preview__column.user-preview__column_hide-name
            .user-preview__item
                router-link.user-preview__link.user-preview__link_large(
                    :to="{name: 'user:profile', params: {id: profile.id, type: profile.type}}"
                )
                    img.user-preview__avatar(:src="profile.avatar")
                    span.preview__text.preview__text_large {{ profile.firstName }} {{ profile.lastName }}
        .col-xs-2.col-sm-1.last-sm.end-xs.user-preview__column
            div
                dropdown(:icon="false" :is-last="isLast" without-move)
                    template(slot="link")
                        svg-icon.user-preview__icon.user-preview__icon_blue(name="select", :size="selectorSize")
                    ul.dropdown__links
                        li.dropdown__link
                            router-link.user-preview__link(:to="{name: 'user:profile', params: {id: profile.id}}")
                                | {{ $i18n.t('list.list_common_actionsOpen') }}
                        li.dropdown__link(v-if="isShowLink")
                            router-link.user-preview__link(:to="{name: 'user:edit', params: {id: profile.id}}")
                                | {{ $i18n.t('list.list_common_actionsEdit') }}
                        li.dropdown__link(v-if="isShowLink")
                            a(
                                href="javascript://"
                                @click="changeStatus"
                                v-if="profile.status === 'active'"
                            )
                                | {{ $i18n.t('list.list_common_actionsArchive') }}
                            a(
                                href="javascript://"
                                @click="changeStatus"
                                v-else
                            )
                                | {{ $i18n.t('list.list_common_actionsRestore') }}
                        li.dropdown__link(v-if="isShowLink")
                            a(
                                href="javascript://"
                                @click="displayConfirmDeleteModal = true"
                            )
                                | {{ $i18n.t('list.list_common_actionsDelete') }}
        .col-xs-12.col-sm-11.user-preview__column
            .user-preview__name.hidden-xs
                router-link.user-preview__link.user-preview__link_large(
                    :to="{name: 'user:profile', params: {id: profile.id, type: profile.type}}"
                )
                    img.user-preview__avatar(:src="profile.avatar")
                    span.preview__text.preview__text_large {{ profile.firstName }} {{ profile.lastName }}
            .row.user-preview__info
                .col-md-6.info__column
                    .user-preview__item
                        template(v-if="profile.status === 'active'")
                            svg-icon.user-preview__icon(name="check")
                            .preview__text {{ $i18n.t('common.common_status_active') }}
                        template(v-else)
                            svg-icon.user-preview__icon(name="cancel")
                            .preview__text {{ $i18n.t('common.common_status_archived') }}
                    .user-preview__item
                        svg-icon.user-preview__icon(name="phone", size="base")
                        .preview__text(v-if="profile.phone")
                            a.user-preview__link(:href="'tel:' + profile.phone")
                                | {{ profile.phone }}
                        .preview__text(v-else)
                            | {{ $i18n.t('list.list_user_noPhone')}}
                .col-md-6.info__column
                    .user-preview__item(
                        v-if="profile.schools.length"
                        v-for="school in profile.schools"
                    )
                        router-link.user-preview__link(v-if="school" :to="{name: 'school:profile', params: {id: school.id}}")
                            svg-icon.user-preview__icon(name="university", size="base")
                            .preview__text {{ school.name }}
                    .user-preview__item(v-else)
                        svg-icon.user-preview__icon(name="university", size="base")
                        .preview__text {{ $i18n.t('list.list_common_noSchool') }}
        confirm-delete-modal(
            v-if="displayConfirmDeleteModal"
            @close="displayConfirmDeleteModal = false"
            @delete="$emit('delete', profile.id)"
        )
            | {{ " " + $i18n.t('list.list_user_deleteAdminModal') }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    import UserApi from '../../../api/user/user';
    import {mapState} from 'vuex';
    import ConfirmDeleteModal from '../../../modals/ConfirmDeleteModal.vue';
    import authentication from '../../../utils/user/authentication'
    import RestoreUserMixin from '../../../utils/user/RestoreUserMixin';

    export default {
        props: {
            profile: Object,
            isLast: Boolean
        },
        data() {
            return {
                displayConfirmDeleteModal: false
            };
        },
        components: {
            Dropdown,
            ConfirmDeleteModal
        },
        mixins: [authentication, RestoreUserMixin],
        computed: mapState({
            user: state => state.auth.user,
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            },
            isShowLink () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        }),
        methods: {
            changeStatus() {
                if (this.profile.status !== 'active' && !this.isRestoreUserAllowed()) {
                    return;
                }
                if (this.profile.status === 'archived') {
                    this.profile.status = 'active';
                } else {
                    this.profile.status = 'archived';
                }
                UserApi.update(this.profile.id, {status: this.profile.status, school: this.profile.school})
                  .then(result => {
                    this.$toasted.success(this.$i18n.t('list.list_user_statusChanged'));
                  })
            },
            deleteAdmin() {
                this.$emit('delete', this.profile.id);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .user-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .user-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 8px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .user-preview__column:last-child {
        margin-bottom: 0;
    }

    .user-preview__column:first-child {
        margin-bottom: 16px;
    }

    .user-preview__column_hide-name {
        @include media($sm) {
            display: none;
        }
    }

    .user-preview__name {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
    }

    .user-preview__icon {
        color: $hsl-color-green-58;
    }

    .user-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .user-preview__items {
        display: flex;
        flex-direction: column;
    }

    .user-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;
    }

    .user-preview__item:not(:last-child) {
        margin-bottom: 8px;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .user-preview__link {
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .user-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .user-preview__avatar {
        border-radius: 50%;
        max-height: none;
        height: 50px;
        width: 50px;
    }

    .user-preview__info {
        margin: -8px 0;
    }

    .info__column {
        padding: 8px 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }
</style>
